import { render, staticRenderFns } from "./nfse_tab.vue?vue&type=template&id=71418c4f&"
import script from "./nfse_tab.vue?vue&type=script&lang=js&"
export * from "./nfse_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports